var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4Cm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 210.221C165.228 210.221 210 165.449 210 110.221C210 54.9922 165.228 10.2207 110 10.2207C54.7715 10.2207 10 54.9922 10 110.221C10 165.449 54.7715 210.221 110 210.221ZM110 150.221C132.091 150.221 150 132.312 150 110.221C150 88.1293 132.091 70.2207 110 70.2207C87.9086 70.2207 70 88.1293 70 110.221C70 132.312 87.9086 150.221 110 150.221Z",
    fill: "#CC9B92",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110.221,
    r: 40,
    stroke: "#37A851",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Cm);
export default __webpack_public_path__ + "static/media/4cm.3b7d4eb92e62ec2e5b15d1a18545807c.svg";
export { ForwardRef as ReactComponent };